import { render, staticRenderFns } from "./popupAnotacao.vue?vue&type=template&id=5fc387d2&scoped=true"
import script from "./popupAnotacao.vue?vue&type=script&lang=js"
export * from "./popupAnotacao.vue?vue&type=script&lang=js"
import style0 from "./popupAnotacao.vue?vue&type=style&index=0&id=5fc387d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc387d2",
  null
  
)

export default component.exports